export default __webpack_public_path__ + "static/media/Arbre_de_la_vie_grand_porte_cle.26ad80dd.png";